var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ion-header',[_c('ion-toolbar',[_c('ion-buttons',{attrs:{"slot":"start"},slot:"start"},[_c('ion-menu-button',{attrs:{"auto-hide":"false","menu":"side-menu"}},[_c('db-img',{attrs:{"icon":"","name":"menu"}})],1)],1),_c('ion-title',[_vm._v("title")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }